import { DOCS_LINKS_ENABLED } from "@/src/constants/docs-links";

export type DocsLinkProps = {
  href?: string;
  children?: React.ReactNode;
  className?: string;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">;

export function DocsLink({
  href,
  children,
  className,
  ...props
}: DocsLinkProps) {
  if (!DOCS_LINKS_ENABLED) {
    return <span className={className}>{children}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      {...props}
    >
      {children}
    </a>
  );
}
